module.exports = __webpack_public_path__ + "static/media/user-tag.dc07da44.svg";